<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Input from "@/components/c-input";
import Button from "@/components/c-button";
import moment from 'moment'
import { paymentService } from "../../../../services/reportservice/paymentservice.js";


/* eslint-disable no-console */
export default {
  page: {
    title: "Principle Payment Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    Button,
    Input,
  },
  data() {
    return {
      title: "Principle Payment Report",
      data: [],
      date: '',

      dataStartDate: '',
      dataEndDate: '',
      dataProjectId:0
    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    this.loadingData();
    
  },
  methods: {
    
     
    loadingData: function() {
      
      paymentService.getPrinciplePayment()
        .then(response => {
          this.data = response.data.payment;
          this.date = response.data.date;
          this.dataStartDate = response.data.date.start_date;
          this.dataEndDate = response.data.date.end_date;
        });
    },
    submitSearch: function() {
      let data = '?project_id='+this.dataProjectId+'&start_date='+this.dataStartDate+'&end_date='+this.dataEndDate
      paymentService.getPrinciplePayment(data)
        .then(response => {
          this.data = response.data.payment;
          this.date = response.data.date;
          this.dataStartDate = response.data.date.start_date;
          this.dataEndDate = response.data.date.end_date;
      });
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    discountPrice(price, discount, dis_type) {
        let total = 0;
        if(dis_type==1){
          total = price * discount / 100;
        }else{
          total = discount
        }
        return total
    },
    formatCurrency(value) {
      if(value == 0 ){
        return '';
      }
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    print() {
      window.print();
    }
  },
  computed: {
    totalPrice() {
      return this.data.reduce(function (sum, item) {
        return sum + item.principal_pay
      }, 0)
    },
    
  }
};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="$t('report.payment.principle')" />
      <div id="print-area">
        <!-- <center> -->
          <div class="row search-area">
              
              <div class="col-sm-2">
                <Input 
                  :type="'date'"
                  :id="'start_date'"
                  v-model="dataStartDate"
                /> 
              </div>
              <div class="col-sm-2">
                <Input 
                  :type="'date'"
                  :id="'end_date'"
                  v-model="dataEndDate"
                /> 
              </div>
              <div class="col-sm-2">
                <Button v-bind:icon="'bx bx-search'"
                  @click="submitSearch()" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'primary'"
                  v-bind:title="$t('general.search')" 
                />
              </div>
          </div>
          <div class="col dblack box-a4l">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="9%"><p>&nbsp;</p></td>
                <td width="50%"><p>&nbsp;</p></td>
                <td width="21%"><p>&nbsp;</p></td>
                <td width="20%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                  <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                  <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h8">ទូរស័ព្ទលេខៈ 092 685 009 | 098 685 009 Email: account@h-residence.net</p>
                </td>
                <td class="">
                    <p class=""><u>{{$t('report.payment.principle')}}</u></p>
                    <p class=""><u>ប្រចាំខែ: {{this.dateFormat(date.start_date)}} - {{this.dateFormat(date.end_date)}}</u></p>
                </td>
              </tr>
              
            </table>
            <br/>
            <table class="content-general h8 project-sumary-table" width="100%">
              
                <tr class="thead">
                  <th>N<u>o</u></th>
                  <th>{{$t('report.payment.customer-name')}}</th>
                  <th>{{$t('report.payment.type')}}</th>
                  <th>{{$t('report.payment.code')}}</th>
                  <th>{{$t('report.payment.date')}}</th>
                  <th>{{$t('report.payment.principle-payment')}}</th>
                </tr>
               
              <tbody>
                <tr v-for="(list, index) in data" :key="index" >

                  <td>{{index + 1}}</td>
                  <td>{{list.customer_name}}</td>
                  <td>{{list.loan_type}}</td>
                  <td>{{list.code}}</td>
                  <td>{{dateFormat(list.pay_date)}}</td>
                  <td>{{formatCurrency(list.principal_pay)}}</td>
                </tr>
              </tbody>
                <tr class="tfoot" v-if="data">
                  <td colspan="5" class="text-end pe-2">{{$t('report.total')}}</td>
                  <td colspan="2" class="text-center border-start border-dark ps-2">{{formatCurrency(totalPrice)}}</td>
                </tr>
            </table>
          
            <div class="row mt-3">
              <div class="col">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>អគ្គនាយកក្រុមហ៊ុន</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>អគ្គនាយកក្រុមហ៊ុន</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>នាយកផ្នែកបច្ចេកទេស</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>ប្រធានគ្រប់គ្រងទូទៅ</p>
                </center>
              </div>
              <div class="col">
               
              </div>
            </div>
          </div>  
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>